export default __webpack_public_path__ + "static/media/shape1.9e08ba82.svg";